import type React from 'react';
import {Paper, Stack, Typography} from '@mui/material';
import {HelpComponent} from '~/components/help-component/HelpComponent';

type Props = {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    /** Explains the section (info icon after the title). */
    help?: string;
    actions?: React.ReactNode;
    /** Render the content without the card (it brings its own border, e.g. a grid or tiles). */
    bare?: boolean;
    children: React.ReactNode;
};

/** A section of the Category Profile: title on the page (Mithra 3.0), content in a card below it. */
export const ProfileSection: React.FC<Props> = ({title, subtitle, help, actions, bare, children}) => (
    <Stack gap={1.25} sx={{minWidth: 0}}>
        <Stack direction="row" alignItems="center" gap={1} sx={{minHeight: 32}}>
            <Typography variant="subtitle1" component="h2" sx={{fontWeight: 600, fontSize: 16}}>{title}</Typography>
            {help && <HelpComponent small helpContent={<Typography variant="body2" sx={{maxWidth: 360}}>{help}</Typography>}/>}
            {subtitle && <Typography variant="body2" color="text.secondary" sx={{flex: 1, minWidth: 0}} noWrap>{subtitle}</Typography>}
            {actions && <Stack direction="row" gap={1} alignItems="center" sx={{ml: 'auto'}}>{actions}</Stack>}
        </Stack>
        {bare ? children : <Paper variant="outlined" sx={{p: 2, borderRadius: 2}}>{children}</Paper>}
    </Stack>
);
